import * as Actions from './actions.js';

export function shippingAddressReducer(state = null, action) {
  switch (action.type) {
    case Actions.SHIPPING_ADDRESS_DATA_TERMINATE_LOADING:
      return action.shippingAddress;
    case Actions.SHIPPING_ADDRESS_UPDATED:
      return action.address;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/SFShippingAddressService/reducers.js